<!-- Barra de botões -->
<div class="grid m-0 p-1" style="background:#f8f9fa; border-bottom:1px solid #dee2e6;">
    <div class="col-12 flex justify-content-between align-items-center">
        <div>
            <!-- Novo Adiantamento (available only in detail mode) -->
            <button pButton type="button" icon="pi pi-plus" label="Novo Adiantamento"
                class="p-button-sm" *ngIf="mode === 'detail'" (click)="inserirNovoAdiantamento()">
            </button>
        </div>
        <button pButton type="button" icon="pi pi-times" title="Sair"
            class="buttonMargin p-button-secondary p-button-sm" (click)="sair()">
        </button>
    </div>
</div>

<div class="grid m-0 px-2 pt-3 pb-2">
    <div class="col-12">
        <p-table [value]="listaAdiantamentos"
                 styleClass="p-datatable-sm p-datatable-striped"
                 [rowHover]="true"
                 [loading]="carregando"
                 responsiveLayout="stack">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width:60px" *ngIf="mode === 'detail'">Cód.</th>
                    <th>Moeda</th>
                    <th style="width:130px">Adiantam. Moeda</th>
                    <th style="width:130px">Adiantamento R$</th>
                    <th>Observação</th>
                    <th style="width:50px"></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-adiant>
                <tr>
                    <td *ngIf="mode === 'detail'">{{ adiant.id }}</td>
                    <td>{{ adiant.fatorMoeda?.moeda?.sigla || adiant.fatorMoeda?.id || 'R$' }}</td>
                    <td>{{ adiant.valorMoeda | currency:'BRL':'symbol':'1.2-4' }}</td>
                    <td>{{ adiant.valor | currency:'BRL':'symbol':'1.2-2' }}</td>
                    <td>{{ adiant.obs }}</td>
                    <td>
                        <button pButton type="button" icon="pi pi-pencil"
                            class="p-button-text p-button-sm"
                            title="Editar"
                            (click)="editarAdiantamento(adiant)">
                        </button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="mode === 'detail' ? 6 : 5" class="text-center">Nenhum adiantamento lançado.</td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</div>
